/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Button } from "@mui/material";
import { Column } from "../../../../interfaces/table";
import { useNavigate } from "react-router";
import { IMeta } from "../../../../interfaces/common";
import { globalOnPageChange } from "../../../../Admin-Dashboard/helpers/on-page-change.helper";
import { globalOnSetFilters } from "../../../../Admin-Dashboard/helpers/on-set-filters.helper";
import { globalOnApplyFilters } from "../../../../Admin-Dashboard/helpers/on-apply-filters.helper";
import { globalOnClear } from "../../../../Admin-Dashboard/helpers/on-clear.helper";
import { globalOnSortAction } from "../../../../Admin-Dashboard/helpers/onFilterAction";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import { IGetStateParams } from "../../../../Admin-Dashboard/interfaces/state.bike24.interface";
import {  getWpTableData } from "../../../../Admin-Dashboard/apiHandler/preference.service";
import EditIcon from "@mui/icons-material/Edit";


const usePreferences = () => {
  const navigation = useNavigate();
  const sideBarAccess = useSelector((data: RootState) => data.sideBarAccess);
  const [rows, updateRows] = useState<any[]>([]);
  const [filters, setFilters] = useState<IGetStateParams>({});
  const [page, setPage] = useState(0);
  const [metaInfo, setMetaInfo] = useState<IMeta | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [logModalOpen, setLogModalOpen] = useState(false);
  const [logModalInfoProp, setLogModalInfoProp] = useState<{
    name: string;
    id: number;
  } | null>(null);

  const hasCreateAccess =
    sideBarAccess.accessData.collections?.["bike_state"]?.update;
  useEffect(() => {
    let params = {
      ...filters,
      page,
    };
    getAwardApiCall(params);
  }, []);

  const columns: Column[] = [
    {
      id: "id",
      label: "Id",
      minWidth: 170,
      align: "center",
      key: "id",
      isSortable: false,
    },
    {
      id: "templateId",
      label: "Template Id",
      minWidth: 170,
      align: "center",
      key: "templateId",
      isSortable: false,
    },
    {
      id: "parentId",
      label: "Parent",
      minWidth: 170,
      align: "center",
      key: "parentId",
      isSortable: false,
    },
    {
      id: "name",
      label: "Name",
      minWidth: 170,
      align: "center",
      key: "name",
      isSortable: false,
    },
    {
      id: "body",
      label: "Template",
      minWidth: 170,
      align: "center",
      key: "body",
      isSortable: false,
    },
    {
      id: "optionKey",
      label: "Option Key",
      minWidth: 170,
      align: "center",
      key: "optionKey",
      isSortable: false,
    },
    {
      id: "actions",
      label: "Actions",
      minWidth: 100,
      align: "center",
      key: "actions",
      isSortable: false,
      render: (_, row: any) => {
        return (
          <div className="flex flex-row-reverse justify-center items-center gap-2">
              <Button onClick={()=>handleViewEntry(row)} variant="text">
                <EditIcon  />
              </Button>
              
          </div>
        );
      },
    },
  ];
  
  
  const onLogModalOpenClose = () => {
    setLogModalInfoProp(null);
    setLogModalOpen(false);
  };

  const formatData = (data: any) => {
    return {
      ...data,
      id: data.id,
      name: data.name,
      preferences: data?.preferences,
    };
  };
  
  const handleNewEntry = () => navigation("/dashboard/user-notification/whatsapp-template/new");
  
  const handleViewEntry = (row: any) => {
    console.log(">>>>>>>row", row);
    if (row?.id) {
      navigation(`/dashboard/user-notification/whatsapp-template/${row.id}`);
    }
  };
  
  const getAwardApiCall = async (params: IGetStateParams) => {
    setIsLoading(true);
    await getWpTableData(params).then((res) => {
      const modifiedRes = res?.data?.map((item: any) =>
        formatData({
          ...item,
          id: item?.id,
          name: item?.name,
          preferences: item?.preferences,
        })
      );
      setMetaInfo(res?.meta);
      updateRows(modifiedRes);
    });
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  };
  
  const filterStructure = [
    {
      type: "inputField",
      name: "id",
      label: "Id",
      key: "id",
    },
  ];

  const onSortAction = (orderBy: string | null, orderType: string | null) => {
    globalOnSortAction(
      setPage,
      getAwardApiCall,
      { ...filters },
      orderBy,
      orderType
    );
    globalOnSetFilters<IGetStateParams>(setFilters, "orderBy", orderBy);
    globalOnSetFilters<IGetStateParams>(setFilters, "orderType", orderType);
  };
  
  return {
    columns,
    rows,
    handleViewEntry,
    handleNewEntry,
    page,
    isLoading,
    onPageChange: (page: number) =>
      globalOnPageChange(page, setPage, getAwardApiCall, { ...filters }),
    metaInfo,
    filterStructure,
    onSetFilters: (key: any, value: any) =>
      globalOnSetFilters<IGetStateParams>(setFilters, key, value),
    filters,
    onApplyFilters: () =>
      globalOnApplyFilters(setPage, getAwardApiCall, { ...filters, page }, 0),
    onClear: () =>
      globalOnClear(setFilters, setPage, getAwardApiCall, filters, 0),
    onSortAction,
    onLogModalOpenClose,
    logModalOpen,
    logModalInfoProp,
    hasCreateAccess,
  };
};

export default usePreferences;
